import React, { useEffect, useState } from 'react';
import { Avatar, Stack, Typography, Tooltip } from '@mui/material';
import { AppColors } from '../Utils/helper/AppColors';
import { useLocation, useNavigate } from 'react-router-dom';
import { setNavbarExpanded } from '../store/reducers/appActions';
import { useDispatch, useSelector } from 'react-redux';
import { mainOptions } from './mainOptions';
import { PATH_NAME } from '../Routes/Pathname';
import CultService from '../Services/CultService';
import { getColorSettings } from '../Utils/helper/commonUtils';

export default function Navlist() {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const company = useSelector((state) => state?.app?.company);

	const [navSettingsVersion, setNavSettingsVersion] = useState(0);
	const [loading, setLoading] = useState(false);

	// Fetch nav list from API if not in localStorage
	useEffect(() => {
		const navSettings = localStorage.getItem('navSettings');
		if (!navSettings && company?._id) {
			setLoading(true);
			CultService.getNavList({ params: { companyId: company._id } })
				.then((res) => {
					if (res?.data?.data) {
						localStorage.setItem('navSettings', JSON.stringify(res.data.data));
						setNavSettingsVersion((v) => v + 1);
						window.dispatchEvent(new Event('navSettingsChanged'));
					}
				})
				.finally(() => setLoading(false));
		}

		const handler = () => setNavSettingsVersion((v) => v + 1);
		window.addEventListener('navSettingsChanged', handler);
		return () => window.removeEventListener('navSettingsChanged', handler);
	}, [company?._id]);

	const navSettings = JSON.parse(localStorage.getItem('navSettings') || '{}');
	const colorSettings = getColorSettings();
	const optionsVisibility = navSettings.options || [];

	const allOptions = mainOptions(pathname);

	const navOptions = optionsVisibility.length
		? optionsVisibility
				.map((opt) => {
					const nav = allOptions.find((n) => n?.label === opt?.label);
					return nav && opt.visible !== false ? { ...nav, visible: opt.visible } : null;
				})
				.filter(Boolean)
		: allOptions.filter((nav) => nav.visible !== false && !!nav.label);

	const navigateToPage = (option) => {
		if (option.upcoming) {
			navigate(PATH_NAME.COMING_SOON);
		} else {
			dispatch(setNavbarExpanded(false));
			navigate(option?.to);
		}
	};

	return (
		<Stack
			height="100%"
			overflow="auto"
			alignItems="center"
			my={1}
			gap={0.5}
			sx={{
				'&::-webkit-scrollbar': {
					display: 'none',
					scrollbarWidth: 'none',
				},
			}}
		>
			{loading ? (
				<Typography sx={{ mt: 4 }}>Loading...</Typography>
			) : (
				navOptions.map((option, index) => {
					const SubOptionsTooltip =
						option.subOptions?.length > 0 ? (
							<Stack sx={theme => ({ bgcolor: theme.palette.primary.lightest_shade })}>
								{option.subOptions.map((subOption, i) => (
									<Stack direction="row" alignItems="center" key={i}>
										{subOption?.icon({
											size: 16,
											color: pathname === subOption.to ? colorSettings.buttonBackground : AppColors.HEADING_TITLE4,
										})}
										<Typography
											key={i}
											onClick={(e) => {
												e.stopPropagation();
												navigateToPage(subOption);
											}}
											sx={{
												fontSize: 14,
												fontWeight: 400,
												lineHeight: '121%',
												fontFamily: 'poppins',
												px: 1,
												py: 0.8,
												cursor: 'pointer',
												color: pathname === subOption.to ? colorSettings.buttonBackground : AppColors.HEADING_TITLE4,
												'&:hover': {
													color: colorSettings.buttonBackground,
												},
											}}
										>
											{subOption.label}
										</Typography>
									</Stack>
								))}
							</Stack>
						) : null;

					return (
						<Tooltip
							key={index}
							title={SubOptionsTooltip}
							placement="right-start"
							slotProps={{
								popper: {
									modifiers: [
										{
											name: 'offset',
											options: {
												offset: [0, -10],
											},
										},
									],
								},
								tooltip: {
									sx: theme => ({
										bgcolor: theme.palette.primary.lightest_shade,
										color: AppColors.DARK_GREY,
										boxShadow: '0 0 4 0 #B9B9F780',
										radius: '5px',
										border: `1px solid ${theme.palette.primary.lightest_shade}`,
									}),
								},
							}}
							disableInteractive={false}
						>
							<Stack
								alignItems="center"
								justifyContent="center"
								mt={index === 8 && 'auto'}
								onClick={() => option.to !== '/mood/insights' && navigateToPage(option)}
								sx={theme => ({
									cursor: 'pointer',
									transition: 'all .2s',
									backgroundColor: option.isSelected ? theme.palette.primary.lightest_shade : AppColors.NEW_BACKGROUND ,
									':hover': { bgcolor: theme.palette.primary.lightest_shade },
								})}
								width={70}
								// height={50}
								borderRadius="5px"
								p={'8px'}
								gap={0.5}
								direction="column"
								boxShadow={option.isSelected ? '0px 4px 4px 0px #B9B9F780' : 'none'}
							>
								{/* <Avatar
									sx={theme => ({
										height: 20,
										width: 20,
										color: theme.palette.primary.primary_shade,
										borderRadius: 0,
									})}
									src={option.icon}
								/> */}
								{option?.icon({
									size: 20,
									color: option.isSelected ? colorSettings.buttonBackground : AppColors.HEADING_TITLE4,
								})}
								<Typography fontFamily="poppins" fontWeight={400} fontSize={10} lineHeight="121%" color={AppColors.HEADING_TITLE}>
									{option?.label}
								</Typography>
							</Stack>
						</Tooltip>
					);
				})
			)}
		</Stack>
	);
}
